export const SUBMIT_CUSTOMERS_ACTION_REQUESTED = "SUBMIT_CUSTOMERS_ACTION_REQUESTED";
export const SUBMIT_CUSTOMERS_ACTION_DISPATCHER = "SUBMIT_CUSTOMERS_ACTION_DISPATCHER";
export const SUBMIT_CUSTOMERS_ERROR_DISPATCHER = "SUBMIT_CUSTOMERS_ERROR_DISPATCHER";
export const CUSTOMERS_LOADING = "CUSTOMERS_LOADING";

//Action Creator
export const submitCustomersAction = (data) => ({
  type: SUBMIT_CUSTOMERS_ACTION_REQUESTED,
  postData: data,
});

//Action Dispatcher
export const submitCustomersActionDispatcher = (data) => ({
  type: SUBMIT_CUSTOMERS_ACTION_DISPATCHER,
  payload: data,
});

export const submitCustomersErrorDispatcher = (data) => ({
  type: SUBMIT_CUSTOMERS_ERROR_DISPATCHER,
  payload: data,
});

export const customerListLoading = (loading) => ({
  type: CUSTOMERS_LOADING,
  payload: loading,
});